<template>
	<div class="annotationMark">
		<slot></slot>
		<div class="annotationMark-question">
			<div class="annotationMark-popup" :class="position ? 'annotationMark-popup_' + position : ''">{{ text }}</div>
		</div>
	</div>
</template>

<script>
import { defineComponent } from '@vue/composition-api'

export default defineComponent({
	props: {
		text: {
			type: String,
		},
		position: {
			type: String,
		},
	},
})
</script>
